import type {
  TableCommandFactory,
  TableContextMenu,
} from 'components/Table/model/TableModel';

type SetTableContextMenu = {
  state: TableContextMenu | null;
};

export const setTableContextMenu: TableCommandFactory<SetTableContextMenu> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.tableContextMenu = command.state;
    });
  };
